import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "@qgiv/core-react";

const ProductLimitMessage = ({
    displayQuantityInput,
    entityReplacedPurchaseLimitMessage,
    limitReached,
    overLimit,
}) => (
    <div className={["col col--12 -padding-bottom--10 -padding-top--5"]}>
        <div
            className={cx(
                overLimit && "-color--system-error",
                (limitReached || overLimit) &&
                    displayQuantityInput &&
                    "-font-weight--bold",
            )}
        >
            {(overLimit || limitReached) && displayQuantityInput && (
                <Icon
                    className="-padding-right--5"
                    glyph="exclamation-circle-solid"
                    type="FontAwesome"
                />
            )}
            <small>{entityReplacedPurchaseLimitMessage}</small>
        </div>
    </div>
);

ProductLimitMessage.propTypes = {
    displayQuantityInput: PropTypes.bool.isRequired,
    entityReplacedPurchaseLimitMessage: PropTypes.string.isRequired,
    limitReached: PropTypes.bool.isRequired,
    overLimit: PropTypes.bool.isRequired,
};

export default ProductLimitMessage;
